// extracted by mini-css-extract-plugin
export default {"container":"stub-box_container__sZFxA","content":"stub-box_content__SJh-y","message":"stub-box_message__smSHI"};